import ModalCrearEtiqueta from "common/components/ModalCrearEtiqueta"
import { MultiSelect } from "primereact/multiselect"
import { useEffect, useState } from "react"

import "./styles.scss"

const CustomMultiSelect = ({
  className = "",
  options = [],
  value,
  onChange,
  itemTemplate,
  selectedItemTemplate,
  panelFooterTemplate,
  toogleCreateModal,
  openCreateModal,
}: $TSMigrationFixMe) => {
  const [internOptions, setInternOptions] = useState([])
  const [filterValue, setFilterValue] = useState({ etiqueta: "" })

  const mapOptionFromList = (items = []) => items?.map(({ label }) => label)

  const addEtiqueta = (paylaod: $TSMigrationFixMe) => {
    const newEtiqueta = { code: internOptions.length, label: paylaod.etiqueta }
    // @ts-expect-error TS(2322): Type '{ code: number; label: $TSFixMe; }' is not assign...
    setInternOptions([...internOptions, newEtiqueta])
    onChange([...value, paylaod.etiqueta])
    toogleCreateModal?.()
  }

  const removeSelectedOption = (label: $TSMigrationFixMe) => {
    const newEtiquetas = value?.filter(
      (etiqueta: $TSMigrationFixMe) => etiqueta !== label
    )
    onChange(newEtiquetas)
  }

  const mapOptionsToList = () => {
    // @ts-expect-error TS(7006): Parameter 'label' implicitly has an 'any' type.
    const mappedOptions = options?.map((label, code) => ({ label, code }))
    setInternOptions(mappedOptions)
  }

  const mapValue = internOptions?.filter(({ label }) => value?.includes(label))

  useEffect(() => {
    mapOptionsToList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options])

  return (
    <>
      <MultiSelect
        value={mapValue}
        options={internOptions}
        onChange={(e) => {
          onChange(mapOptionFromList(e.value))
        }}
        filter
        className={`multiselect-custom ${className}`}
        itemTemplate={itemTemplate}
        selectedItemTemplate={(option) =>
          selectedItemTemplate?.(option, removeSelectedOption)
        }
        // TODO: i18n
        emptyFilterMessage='Sin resultado...'
        panelFooterTemplate={panelFooterTemplate}
        showClear
        maxSelectedLabels={1000}
        onFilter={(e) => setFilterValue({ etiqueta: e.filter })}
      />
      <ModalCrearEtiqueta
        data={filterValue}
        visible={openCreateModal}
        onHide={toogleCreateModal}
        options={internOptions}
        onSubmit={addEtiqueta}
      />
    </>
  )
}

export default CustomMultiSelect
